import {
    call,
    put,
    select,
    takeLatest,
    takeEvery,
    all,
    delay
  } from 'redux-saga/effects';
 
  import * as constants from './constants';
  import moment from 'moment';
  import api from '../../util/api';
  import helper from '../../util/helper';
  
  import makeSelectWasteUnitScreen from './selector';
  import { getLimbahUnitFail, getLimbahUnitSuccess, getMoreLimbahUnitFail, getMoreLimbahUnitSuccess, getMoreWOReportFail, getMoreWOReportSuccess, getWorkOrderReportFail, getWorkOrderReportSuccess } from './actions';
  
  export function* doGetListLimbahUnit(action) {
    const dataset = yield select(makeSelectWasteUnitScreen());
    try {
      const tglAwal = moment(dataset.start_dt).format("YYYY-MM-DD");
      const tglAkhir = moment(dataset.end_dt).format("YYYY-MM-DD HH:mm:ss");
      
      const params = {
        tgl_awal: tglAwal+' 00:00:00',
        tgl_akhir: tglAkhir,
        search: dataset.q,
        status: dataset.filter_status
      };

      if(helper.isEmpty(dataset.start_dt)) delete params.tgl_awal;
      if(helper.isEmpty(dataset.end_dt)) delete params.tgl_akhir;
      if(helper.isEmpty(dataset.q)) delete params.search;
      if(helper.isEmpty(dataset.filter_status)) delete params.status;

      const response = yield call(api.waste.getWasteUnitList, params, dataset.page);
      const {success} = response.data;
      console.log("res:", success);
      if(dataset.page == 1){
        yield put(
          getLimbahUnitSuccess((helper.isEmpty(success) ? [] : success)),
        );
      } else {
        yield put(
          getMoreLimbahUnitSuccess((helper.isEmpty(success) ? [] : success)),
        );
      }
    } catch (err) {
      console.log(err);
      helper.errorToast("Terjadi kegagalan proses ambil data pastikan koneksi internet anda normal atau segera hubungi admin");
      if(dataset.page == 1){
        yield put(getLimbahUnitFail(err));
      } else {
        yield put(getMoreLimbahUnitFail(err));
      }
    }
  }

  // Individual exports for testing
  export default function* wasteUnitScreenSaga() {
    yield all([
      takeLatest(constants.GET_LIMBAH_UNIT, doGetListLimbahUnit),
      takeLatest(constants.GET_MORE_LIMBAH_UNIT, doGetListLimbahUnit),
    ]);
  }
  